import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "src/app/providers/authentication.service";

@Component({
  selector: "app-guest-event-birthday-card-edit",
  templateUrl: "./guest-event-birthday-card-edit.component.html",
  styleUrls: ["./guest-event-birthday-card-edit.component.scss"],
})
export class GuestEventBirthdayCardEditComponent implements OnInit {
  constructor(private router: Router,
    private authService: AuthenticationService,
  ) {}

  async ngOnInit() {
    await this.authService.isAuthenticated();
  }

  gotoBirthdayCardSigned() {
    this.router.navigate(["/guest/23452354/birthdaycard/signed"]);
  }
}
